import axios from 'axios'
import { saveToLocalStorage } from '@/../../shared/src/store/plugins/localStorage'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.xsrfCookieName = 'csrftoken'

function analyseMutation (mutationType) {
  if (mutationType.indexOf('/') > -1) {
    const mutationParts = mutationType.split('/')
    return {
      'module': mutationParts[0],
      'action': mutationParts[1]
    }
  }
}

function logFailure ({module, action}, payload) {
  return axios.post('/api/virtual-classroom/troubleshooter-log/' + payload.userId + '/', payload)
}

export function logFailurePlugin () {

  return (store) => {

    store.subscribe((mutation, state) => {

      const mutationParts = analyseMutation(mutation.type)

      if (mutationParts.action.match(/pass|fail|skip|start/i) && mutation.payload && mutation.payload.userId) {
        logFailure(mutationParts, mutation.payload)
      }

      if (mutationParts.action === 'pass' && mutation.payload && mutation.payload.userId) {
        saveToLocalStorage('lc-media-opts', state.preview[`${state.preview.videoProvider}MediaOpts`])
      }

    })
  }
}
